module.exports = __webpack_public_path__ + "static/media/acc.6acea57c.svg";